export default function getBaseUrl () {
    return "https://hipartsbot.uz/api/v1";
};
